// ChatHistorySideNav.js (a.k.a. SessionListAll.jsx)
import React, { useState, useEffect } from "react";
import {
  EuiPanel,
  EuiListGroup,
  EuiListGroupItem,
  EuiFlexGroup,
  EuiFlexItem,
  EuiAvatar,
  EuiHorizontalRule,
} from "@elastic/eui";
import { PostOptions } from "../utils/RequestUtils";

const SessionListAll = ({
  course,
  agent,
  selectedSession,
  setSelectedSession,
  setChatHistory,
  setAllData,
}) => {
  const [sessions, setSessions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);

    let config_name = agent ? agent.config_name : "";
    if (config_name === "All Agents") {
      config_name = "";
    }

    fetch(
      "/api/session/get/all/course",
      PostOptions({
        course_name: course.course_name,
        course_number: course.course_number,
        config_name: config_name,
      })
    )
      .then((response) => {
        return response.json().then((text) => {
          if (!response.ok) {
            alert(text.message);
            throw new Error(text.message);
          }
          return text;
        });
      })
      .then((data) => {
        setIsLoading(false);

        // Save all data (for charts, etc.)
        setAllData(data.data);

        // Separate sessions by time categories
        const currentTime = new Date();
        const today = [];
        const yesterday = [];
        const lastWeek = [];
        const older = [];

        data.data.forEach((session) => {
          const sessionTime = new Date(session.date_and_time);
          const diff = currentTime - sessionTime;
          const days = diff / (1000 * 60 * 60 * 24);

          if (days < 1) {
            today.push(session);
          } else if (days < 2) {
            yesterday.push(session);
          } else if (days < 7) {
            lastWeek.push(session);
          } else {
            older.push(session);
          }
        });

        const sessionGroups = [];
        if (today.length > 0) {
          sessionGroups.push({ name: "Today", items: today });
        }
        if (yesterday.length > 0) {
          sessionGroups.push({ name: "Yesterday", items: yesterday });
        }
        if (lastWeek.length > 0) {
          sessionGroups.push({ name: "Last Week", items: lastWeek });
        }
        if (older.length > 0) {
          sessionGroups.push({ name: "Older", items: older });
        }

        setSessions(sessionGroups);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsLoading(false);
      });
  }, [agent, course, setAllData]);

  return (
    <EuiPanel
      paddingSize="none"
      style={{ height: "80vh", overflow: "auto", maxWidth: "30vw" }}
      color="subdued"
      grow
    >
      {sessions.map((group, groupIndex) => (
        <EuiPanel key={groupIndex} hasShadow={false} hasBorder={false}>
          <h3>{group.name}</h3>
          <EuiHorizontalRule margin="xs" />
          <EuiListGroup flush>
            {group.items.map((item, itemIndex) => {
              const uniqueKey = `${item.session_name}-${item.session_owner}-${itemIndex}`;
              return (
                <EuiFlexGroup key={uniqueKey} gutterSize="xs">
                  {/* Provide a fallback name for config_name to avoid "undefined" errors */}
                  <EuiFlexItem grow={1}>
                    <EuiAvatar
                      size="s"
                      name={item.config_name || "No config"}
                    />
                  </EuiFlexItem>

                  {/* Provide a fallback name for session_owner as well */}
                  <EuiFlexItem grow={1}>
                    <EuiAvatar
                      size="s"
                      name={item.session_owner || "No owner"}
                    />
                  </EuiFlexItem>

                  <EuiFlexItem grow={10}>
                    <EuiListGroupItem
                      isActive={
                        selectedSession &&
                        selectedSession.session_name +
                          selectedSession.session_owner ===
                          item.session_name + item.session_owner
                      }
                      label={item.session_name}
                      onClick={() => {
                        setSelectedSession(item);
                        setChatHistory(item.chat_history);
                      }}
                    />
                  </EuiFlexItem>
                </EuiFlexGroup>
              );
            })}
          </EuiListGroup>
        </EuiPanel>
      ))}
    </EuiPanel>
  );
};

export default SessionListAll;
